module.exports = __webpack_public_path__ + "static/media/s14.57ed1391.jpg";